import React from "react";
import "./GameIntroScreen.css";
import GOQii_logo from "../../assets/img/GOQii_logo.png";
import button from "../../assets/img/button.png";

export default function GameIntroScreen({
    backgroundImage,
    gameLogo,
    title,
    onStart
}) {
    return (
        <div
            className="intro-wrapper intro-screen-container"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            {/* 1️⃣ GAME LOGO (Top) */}
            <div className="intro-logo">
                <img src={gameLogo} alt="Game Logo" />
            </div>

            {/* 2️⃣ TITLE (Below Logo) */}
            <div className="intro-title">
                <h1>{title}</h1>
            </div>

            {/* 3️⃣ GOQii LOGO (Pushed to Bottom) */}
            <div className="intro-goqii">
                <img src={GOQii_logo} alt="GOQii" />
            </div>

            {/* 4️⃣ PLAY BUTTON (Bottom most) */}
            <div className="intro-button">
                <img src={button} alt="Start" onClick={onStart} />
            </div>
        </div>
    );
}